import React, {useState} from 'react';
import {gql} from '@apollo/client';
import useGuardedQuery from '@src/hooks/useGuardedQuery';
import {EzManageNavQuery} from '@src/__generated__/EzManageNavQuery';
import SupportModal from '../SupportModal';
import Navigation from './Navigation';
import {ContentWraper, NavWrapper, PageWrapper} from './Navigation/components';
import {SidebarProvider} from '../shadcn/sidebar';

type EzManageNavProps = React.PropsWithChildren<{
  openLiveChat?: (() => void) | null;
}>;

const EzManageNav: React.FC<EzManageNavProps> = ({children, openLiveChat}) => {
  const {data} = useGuardedQuery<EzManageNavQuery, object>(ezManageNavQueryGql, {
    errorPolicy: 'ignore',
  });
  const catererAccount = data?.me?.catererAccount ?? null;
  const constants = data?.constants ?? null;
  const liveChatEnabled = (openLiveChat && data?.liveChat?.isEnabled) ?? false;
  const [supportModalOpen, setSupportModalOpen] = useState(false);

  const handleOpenChat = () => {
    setSupportModalOpen(false);
    if (openLiveChat) openLiveChat();
  };

  const handleSupportLabelClicked = (
    event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => {
    setSupportModalOpen(true);
    event.preventDefault();
  };

  const handleDismissModal = () => {
    setSupportModalOpen(false);
  };

  return (
    <SidebarProvider>
      <PageWrapper>
        <NavWrapper>
          <Navigation
            liveChatEnabled={liveChatEnabled}
            openLiveChat={openLiveChat}
            handleSupportLabelClicked={handleSupportLabelClicked}
          />
        </NavWrapper>
        <ContentWraper>{children}</ContentWraper>
        <SupportModal.Component
          catererAccount={catererAccount}
          constants={constants}
          dismissModal={handleDismissModal}
          liveChatEnabled={liveChatEnabled}
          open={supportModalOpen}
          openChat={handleOpenChat}
        />
      </PageWrapper>
    </SidebarProvider>
  );
};

export const ezManageNavQueryGql = gql`
  query EzManageNavQuery {
    constants {
      ...EzManageNavSupportModalConstants
    }
    liveChat {
      isEnabled
    }
    me {
      id
      catererAccount {
        id
        name
        ...EzManageNavSupportModalCatererAccount
      }
    }
  }

  ${SupportModal.fragment}
`;

export default EzManageNav;
